import React, { useEffect, useState } from 'react';

import { removeLocalStorage, setLocalStorage } from 'services/common/storage';
import { useAppSelector } from 'store/hooks';
import { LOCAL_STORAGE } from 'utils/constants';
import mapModifiers from 'utils/functions';

const HeaderRecruitment = React.lazy(() => import('./HeaderRecruitment'));
const FooterRecruitment = React.lazy(() => import('./FooterRecruitment'));
const Footer = React.lazy(() => import('./Footer'));
const HeaderContainer = React.lazy(() => import('./Header'));

const MainLayoutHeader: React.FC = () => {
  const layoutType = useAppSelector((state) => state.layout.layoutType);
  const [currentLayout, setCurrentLayout] = useState('pending');

  useEffect(() => {
    if (layoutType === 'recruit-layout') {
      setLocalStorage(LOCAL_STORAGE.IS_RECRUITMENT, 'true');
    } else {
      removeLocalStorage(LOCAL_STORAGE.IS_RECRUITMENT);
    }
    setCurrentLayout(layoutType);
  }, [layoutType]);

  switch (currentLayout) {
    case 'recruit-layout':
      return <HeaderRecruitment />;
    case 'main-layout':
    case 'error':
      return <HeaderContainer />;
    case 'ekyc':
      return <HeaderContainer isEkyc />;
    default:
      return null;
  }
};

const MainLayoutFooter: React.FC = () => {
  const layoutType = useAppSelector((state) => state.layout.layoutType);
  const [currentLayout, setCurrentLayout] = useState('pending');

  useEffect(() => {
    setCurrentLayout(layoutType);
  }, [layoutType]);

  switch (currentLayout) {
    case 'recruit-layout':
      return <FooterRecruitment />;
    case 'main-layout':
    case 'error':
    case 'ekyc':
      return <Footer />;
    default:
      return null;
  }
};

const MainLayoutContainer: React.FC = ({ children }) => {
  const layoutType = useAppSelector((state) => state.layout.layoutType);

  return (
    <>
      <MainLayoutHeader />
      <main
        className={mapModifiers(
          'main-layout',
          layoutType === 'recruit-layout' ? 'recruit' : '',
          layoutType === 'ekyc' ? 'ekyc' : '',
        )}
      >
        {children}
      </main>
      <MainLayoutFooter />
    </>
  );
};

export default MainLayoutContainer;
